(function(){
	function ViewTransition()
	{
		this.Container_constructor();
		this.name = 'view-transition';
	}

	var p = createjs.extend(ViewTransition, cjs.Container);

	p.build = function()
	{
		this.curtains = new cm.Assets.lib.CurtainsAnim.mc_fader();
		this.curtains.stop();
		this.curtains.set({scaleX: 1.05, scaleY: 1.05, framerate: 30, visible: false, "x":130,"y":54});
		// this.curtains.set({framerate: 30, visible: false});
		this.addChild(this.curtains);
	};

	p.transitOut = function(onAnimationEndCallback)
	{
		
		if (onAnimationEndCallback) {
			this.curtains.onAnimationEndCallback = function() {
				onAnimationEndCallback();
				this.curtains.visible = false;
			}.bind(this);
		}
		this.curtains.gotoAndPlay('hide');
	};

	p.transitIn = function(onAnimationEndCallback)
	{	

		this.curtains.visible = true;
		if (onAnimationEndCallback) {
			this.curtains.onAnimationEndCallback = onAnimationEndCallback;
		}
		this.curtains.gotoAndPlay('show');
	};

	p.justHide = function() {
		this.curtains.visible = false;
		this.curtains.gotoAndStop('show');
	};

	cm.ViewTransition = cjs.promote(ViewTransition, "Container");
})();